import { atom } from "jotai";

import { commandPaletteAtom, initialState } from "./state";

export const isVisibleAtom = atom(
  (get) => get(commandPaletteAtom).isVisible,
  (_get, set, value: boolean) => {
    set(commandPaletteAtom, (draft) => {
      draft.isVisible = value;
    });
  },
);

export const showAtom = atom(null, (_get, set) => {
  set(isVisibleAtom, true);
});

export const hideAtom = atom(null, (_get, set) => {
  set(commandPaletteAtom, (draft) => {
    draft.isVisible = false;
    draft.query = initialState.query;
    draft.highlightedIndex = initialState.highlightedIndex;
    draft.filterTokens = initialState.filterTokens;
  });
});

export const toggleAtom = atom(null, (get, set) => {
  if (get(isVisibleAtom)) {
    set(hideAtom);
  } else {
    set(showAtom);
  }
});
